import MuiTextField from '@mui/material/TextField';
import type CSS from 'csstype';
import {
  DEFAULT_COMPONENT_HEIGHT,
  DEFAULT_INPUT_DESKTOP_PADDING,
  DEFAULT_INPUT_MOBILE_PADDING,
  DEFAULT_INPUT_STYLED,
} from '../../../constants';

type MuiTextFieldProps = {
  value: string | number | undefined;
  onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void,
  onBlur?: () => void,
  id?: string;
  name?: string;
  variant?: unknown;
  isRequired?: boolean;
  isError?: boolean;
  type?: string;
  label?: string | React.ReactElement;
  disabled?: boolean;
  height?: string;
  textalign?: CSS.Property.TextAlign;
  fontSize?: CSS.Property.FontSize;
  cursor?: CSS.Property.Cursor,
};

const TextField: React.FunctionComponent<MuiTextFieldProps> = (props: any) => {
  return (
    <MuiTextField
      {...props}
      name={props.name}
      id={props?.id}
      error={props?.isError || (props.isRequired && !props?.value)}
      color="primary"
      variant={props?.variant ?? DEFAULT_INPUT_STYLED}
      value={props.value}
      onChange={props?.onChange}
      onFocus={props?.onFocus}
      onBlur={props?.onBlur}
      fullWidth={true}
      type={props?.type}
      label={props?.label}
      disabled={props.disabled}
      sx={{
        '& input': {
          boxSizing: 'border-box',
          padding: DEFAULT_INPUT_DESKTOP_PADDING,
          height: props?.height ?? DEFAULT_COMPONENT_HEIGHT,
          textAlign: props?.textalign ?? 'initial',
          fontSize: `${props?.fontSize ?? 'var(--main-font-size)'} !important`,
          cursor: props?.cursor,
        },
        '& label': {
          transform: 'translate(14px, 12px) scale(1) !important',
        },
        '& label.MuiFormLabel-filled': {
          transform: 'translate(20px, -5px) scale(0.75) !important',
        },
        '& label.Mui-focused': {
          transform: 'translate(20px, -5px) scale(0.75) !important',
          color: 'var(--primary-main-color)',
        },
        '@media (max-width: 768px)': {
          '& input': {
            padding: DEFAULT_INPUT_MOBILE_PADDING,
          },
          '& input:focused + fieldset': {
            borderColor: `${props?.isError ? 'var(--secondary-main-color)' : 'var(--primary-main-color)'} !important`,
          },
          '& fieldset': {
            borderradius: '21px',
            borderColor: `${props?.isError ? 'var(--secondary-main-color)' : 'var(--main-font-color)'}`,
          },
        },
      }}
    />
  );
};

export default TextField;
